<template>
  <div class="p-grid p-pb-6">
    <div class="p-col-12 p-pt-1 p-pb-1">
      <div class="p-grid p-ai-center p-pt-1 vertical-container">
        <div class="p-col-fixed" style="width:55px;">
          <a @click="$functions.historyBack()" style="cursor: pointer">
            <img class="" src="assets/irinox/icons/arrow_back.svg" :alt="$t('common.arrow_left')" />
          </a>
        </div>
        <div class="p-col">
          <h3>{{ appliance.name ?? $functions.fixModelName(appliance.modelNumber) }} - {{ $t('frevi.title') }}</h3>
        </div>
      </div>

      <div class="p-mb-4">{{ $t('frevi.description') }}</div>

      <div class="irinox-form frevi">

        <DataTable :value="movements" stripedRows responsiveLayout="stack" dataKey="eventId" breakpoint="960px" :sortField="'timestamp'" :sortOrder="-1">
           <template #empty>
            {{ $t('frevi.empty_list') }}
          </template>
          <template #loading>
            {{ $t('frevi.loading_list') }}
          </template>

          <Column field="timestamp" :header="$t('frevi.col_datetime')">
            <template #body="slotProps">
                {{ $d( slotProps.data.timestamp * msConverter , is24hour ? 'full' : 'full12' ) }}
            </template>
          </Column>

          <Column field="operation" :header="$t('frevi.col_operation')">
            <template #body="slotProps">
                <i v-if="slotProps.data.operation == 'ADD'" class="pi pi-plus-circle" style="color: #38B000;"></i>
                <i v-else-if="slotProps.data.operation == 'SUB'" class="pi pi-minus-circle" style="color: #F80707;"></i>
                <i v-else class="pi pi-question-circle" style="color: #969696;"></i>
            </template>
          
          </Column>

          <Column field="level" :header="$t('frevi.col_level')"></Column>

          <Column field="category" :header="$t('frevi.col_category')"></Column>

          <Column field="quantity" :header="$t('frevi.col_quantity')"></Column>

          <Column></Column>

        </DataTable>

      </div>

    </div>
  </div>

  <!--        -->
  <!-- ERRORS -->
  <!--        -->
  <IrinoxDialogDark :visible="dialog.error" mode="error" :message="$t('details.dialog_error')" :life="3000"
    @update:visible="dialog.error = $event" />

</template>

<script>
import ApplianceService from '../../service/ApplianceService';
import IrinoxDialogDark from '../IrinoxDialogDark.vue';
import { mapGetters } from 'vuex';

export default {
  components: {
    IrinoxDialogDark,
  },
  data() {
    return {
      msConverter: 1000,
      serialNumber: this.$route.params.serialNumber,
      movements: [],
      dialog: {
        error: false,
      }
    };
  },
  computed: {
    ...mapGetters({
      personaltoken: 'userdata/personaltoken',
      is24hour: 'userdata/is24hour',
      role: 'userdata/role',
      email: 'userdata/email',
    }),
    appliance: function () {
      return this.$store.getters['appliances/appliance'](this.serialNumber);
    },
  },
  watch: {
  },
  created() {
    this.applianceService = new ApplianceService();
  },
  mounted() {
    this.reloadMovements();
  },
  methods: {
    reloadMovements() {
      this.applianceService.getFreviApplianceMovements(this.personaltoken, this.serialNumber)
        .then((data) => {
          if (data.code == "200") {
            this.movements = data.body;
          } else {
            console.error("ERROR " + JSON.stringify(data));
            this.dialog.error = true;
          }
        })
        .catch(error => {
          console.error("ERROR " + error);
          this.dialog.error = true;
        });
    },
  }

}
</script>

<style scoped></style>